<template>
  <div v-if="tiles">

        <v-row>
          <template v-for="card in tiles">
            <v-col cols="4" :key="`word-${card.el}`">
              <div class="guage">
                <div class="guage__percent">
                  <div
                    class="guage__percent__bar"
                    :style="{ width: card.percentage }"
                  >
                    <p>{{ card.title }}</p>
                  </div>
                </div>
              </div>
            </v-col>
          </template>
        </v-row>
      </div>
</template>

<script>


export default {
  name: "TilesWords",
  props: {
    tiles: {
      type: Array,
      default: null,
    },
  }
};
</script>
